<div class="vm-tile-container"><ng-content></ng-content></div>
